import { BooleanInput,coerceBooleanProperty } from '@angular/cdk/coercion';
import { CommonModule } from '@angular/common';
import { AfterViewInit,Component,HostListener,Input,OnDestroy,ViewChild } from '@angular/core';
import { FormControl,FormGroup,FormsModule,ReactiveFormsModule,UntypedFormBuilder,ValidationErrors,ValidatorFn,Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { ResolveData } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Actions,ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { async, BehaviorSubject, combineLatest, firstValueFrom, Observable, of, Subscription } from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    filter,
    map,
    shareReplay, startWith,
    switchMap, take, tap,
} from 'rxjs/operators';
import { AccountTypeEnum,ChartOfAccountEntity } from '../../../../dave-data-module/entities/chart-of-Account.entity';
import { CustomerTypeEntity } from '../../../../dave-data-module/entities/customer-type.entity';
import {
    CustomerEntity,
    CustomerStatusEnum,
    SupplierCustomerNumber,
} from '../../../../dave-data-module/entities/customer.entity';
import { CustomerSpecificationTypeEntity } from '../../../../dave-data-module/entities/customerSpecificationType.entity';
import { MandateTypeEntity,MandateTypeNames } from '../../../../dave-data-module/entities/mandate-type.entity';
import { PartnerOfficeEntity } from '../../../../dave-data-module/entities/partnerOffice.entity';
import { Person2EntityEntityTypeEnum } from '../../../../dave-data-module/entities/person2entity.entity';
import { DaveMutationCreateCustomerWithOfficePersonArgs } from '../../../../dave-data-module/graphql-types';
import { ChartOfAccountResolver } from '../../../../dave-data-module/guards/chartOfAccount.resolver';
import { CustomerResolver } from '../../../../dave-data-module/guards/customer.resolver';
import { CustomerSpecificationTypeResolver } from '../../../../dave-data-module/guards/customerSpecificationType.resolver';
import { MandateTypeResolver } from '../../../../dave-data-module/guards/mandate-type.resolver';
import { PartnerOfficeResolver } from '../../../../dave-data-module/guards/partner-office.resolver';
import { ComponentCanDeactivate } from '../../../../dave-data-module/guards/pending-changes.guard';
import { PersonResolver } from '../../../../dave-data-module/guards/person.resolver';
import { getFetched$ } from '../../../../dave-data-module/helper/helper';
import { State } from '../../../../dave-data-module/State';
import { BaseActionTypes } from '../../../../dave-data-module/State/actions/base.actions';
import { ChartOfAccountActionTypes } from '../../../../dave-data-module/State/actions/chartOfAccount.actions';
import { CustomerActionTypes } from '../../../../dave-data-module/State/actions/customers.actions';
import { Person2EntityActionTypes } from '../../../../dave-data-module/State/actions/person2entity.action';
import { customersFeatureKey } from '../../../../dave-data-module/State/reducers/customers.reducer';
import { customerSpecificationTypesFeatureKey } from '../../../../dave-data-module/State/reducers/customerSpecificationType.reducer';
import { MANDATE_TYPE_KEY } from '../../../../dave-data-module/State/reducers/mandate-type.reducer';
import { personsFeatureKey } from '../../../../dave-data-module/State/reducers/person.reducer';
import { getChartOfAccounts,getChartOfAccountsFetched } from '../../../../dave-data-module/State/selectors/chartOfAccount.selectors';
import { getCustomers, getCustomerTypeFetched } from '../../../../dave-data-module/State/selectors/customers.selectors';
import {
    getCustomerSpecificationTypes,
    getCustomerSpecificationTypesFetched,
} from '../../../../dave-data-module/State/selectors/customerSpecificationType.selectors';
import { getMandateTypes,getMandateTypesFetched } from '../../../../dave-data-module/State/selectors/mandate-types.selectors';
import {
    getOwnPartnerOffices, getPartner,
    getPartnerFetched,
    getPartnerOfficesFetched,
} from '../../../../dave-data-module/State/selectors/partners.selectors';
import { getUser } from '../../../../dave-data-module/State/selectors/users.selectors';
import { AppButtonModule } from '../../../../dave-utils-module/app-button-module/app-button.module';
import { AppConfirmationDialogComponent,AppConfirmationDialogData,AppConfirmationDialogReturnData } from '../../../../dave-utils-module/app-dialog-module/app-confirmation-dialog/app-confirmation-dialog.component';
import { DaveSharedComponentsModule } from '../../../../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { GoogleMapsService } from '../../../../dave-utils-module/dave-shared-components-module/services/google-maps.service';
import { RoutingHistoryService } from '../../../../dave-utils-module/dave-shared-components-module/services/routing-history.service';
import {
SelectSearchLegacyComponent
} from '../../../../dave-utils-module/select-search/components/select-search-legacy/select-search-legacy.component';
import { SelectSearchOption } from '../../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { SelectSearchModule } from '../../../../dave-utils-module/select-search/select-search.module';
import { DetailListDialogReturn,DetailListTemplateDialogComponent,DetailListTemplateDialogData } from '../../../../detail-list-template-dialog/components/detail-list-template-dialog.component';
import { DetailListTemplateDialogModule } from '../../../../detail-list-template-dialog/detail-list-template-dialog.module';
import {
EditCustomerspecificationtypeComponent
} from '../../../../detail-list-template-dialog/edit-customerspecificationtype/edit-customerspecificationtype.component';
import {
    capitalizeFirstLetter,
    isNotNullOrUndefined,
    SearchQueriesDebounceTime,
    stringSearch,
} from '../../../../helper/helper';
import { decimalValidator,phoneNumberValidator,someRequiredValidator } from '../../../../helper/validation.helper';
import { HintIconComponent } from '../../../../hint-icon/hint-icon.component';
import { CustomLabelService } from '../../../../services/custom-label/custom-label.service';
import { LoadingService } from '../../../../services/loading.service';
import { CustomerTypeChipAutocompleteComponent } from '../../../templates/customer-type-chip-autocomplete/customer-type-chip-autocomplete.component';
import {
    CustomerSpecificationTypeActionTypes
} from '../../../../dave-data-module/State/actions/customerSpecificationType.actions';
import { ComplaintTypeIdEnum } from '../../../../dave-data-module/entities/complaintType.entity';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { TAX_TYPE_FEATURE_KEY } from '../../../../dave-data-module/State/reducers/tax-type.reducer';
import { TaxTypeResolver } from '../../../../dave-data-module/guards/tax-type.resolver';
import { TaxTypeEntity } from '../../../../dave-data-module/entities/tax-type.entity';
import { getTaxTypeById, getTaxTypesActive } from '../../../../dave-data-module/State/selectors/tax-type.selectors';
import { CustomerTypeResolver } from '../../../../dave-data-module/guards/customer-type.resolver';

export type newCustomerDefaultValues = {
    name?: string;
    firstName?: string;
    lastName?: string;
    customer?: any;
    office?: any;
};
@Component({
    selector: 'app-new-customer-main',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SelectSearchModule,
        DaveSharedComponentsModule,
        MatSlideToggleModule,
        FontAwesomeModule,
        MatTooltipModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatSelectModule,
        CustomerTypeChipAutocompleteComponent,
        DetailListTemplateDialogModule,
        AppButtonModule,
        MatRadioModule,
        HintIconComponent,
        FormsModule,
        EditCustomerspecificationtypeComponent,
        MatLegacyInputModule,
    ],
    templateUrl: './new-customer-main.component.html',
    styleUrls: ['./new-customer-main.component.scss'],
})
export class NewCustomerMainComponent implements OnDestroy, ComponentCanDeactivate, AfterViewInit {
    @ViewChild('company') companySelect: SelectSearchLegacyComponent;
    public static readonly RequiredResolvers: ResolveData = {
        [customerSpecificationTypesFeatureKey]: CustomerSpecificationTypeResolver,
        partnerOffice: PartnerOfficeResolver,
        [MANDATE_TYPE_KEY]: MandateTypeResolver,
        [customersFeatureKey]: CustomerResolver,
        [personsFeatureKey]: PersonResolver,
        [TAX_TYPE_FEATURE_KEY]: TaxTypeResolver,
    };

    /** (NN) Die Werte, die im Template verwendet werden */
    public Data$: Observable<{
        // AreFormsInvalid: boolean;
        MandateTypes: MandateTypeEntity[];
    }>;

    /** Das eventuell hochzuladende Profilbild des anzulegenden Kunden */
    public CustomerImageFile?: File;

    /**
     * FormControl für den Namen des Unternehmens.
     *
     * Ausgegliedert in eine alleinstehende FormControl, da somit die Validierung ohne schwer zu
     * debuggende Aufrufe von `FormControl.disable()` und `FormControl.enable()` vonstattengeht.
     */
    public NameForm = this.fb.control(null, [Validators.required]) as FormControlTyped<string | null>;
    public FirstnameForm = new FormControl<string | null>(null);
    public LastNameForm = new FormControl<string>(null, Validators.required);
    public CustomerTypesForm = this.fb.control([]) as FormControlTyped<CustomerTypeEntity[]>;
    public isPrivatePerson: boolean = false;
    public isSupplier: boolean = false;
    public SupplierCustomerNumbers: SupplierCustomerNumber[] = [];

    protected createCustomerAndSupplier = false;
    protected taxOptions$: Observable<TaxTypeEntity[]> = this.store.select(getTaxTypesActive);
    /** FormGroup für die Kundendaten */
    public CustomerForm = new FormGroup(
        {
            CustomerId: new FormControl<string | null>({ value: null, disabled: true }),
            AutomaticCustomerId: new FormControl<boolean>(true),
            Description: new FormControl<string | null>(null),
            Sales: new FormControl<number | null>(null),
            EmployeeNumber: new FormControl<number | null>(null),
            PartnerOfficeId: new FormControl<PartnerOfficeEntity | null>(null),
            Homepage: new FormControl<string | null>(null),
            MandateTypeId: new FormControl<number | null>(null),
            CustomerSpecificationType: new FormControl<CustomerSpecificationTypeEntity | null>(null),
            Gerichtsort: new FormControl<string | null>({ value: null, disabled: true }),
            AutomaticAccountsReceivableLedger: new FormControl<boolean>(false),
            UstId: new FormControl<string | null>(null),
            Steuernummer: new FormControl<string | null>(null),
            DebitorNo: new FormControl<string | null>(null),
            TaxTypeId: new FormControl<number | null>(null),
            Sachkonto: new FormControl<SelectSearchOption<ChartOfAccountEntity> | null>(null),
            Konto: new FormControl<SelectSearchOption<ChartOfAccountEntity> | null>(null),
            BuyerReference: new FormControl<string | null>(null),
            PaymentTerms: new FormControl<string | null>(null),
            PaymentTargetInDays: new FormControl<number | null>(null, [decimalValidator()]),
            PaymentDiscount: new FormControl<number | null>(null, [Validators.min(0), Validators.max(100), decimalValidator(4)]),
            PaymentDiscountTargetInDays: new FormControl<number | null>(null, [decimalValidator()]),
            IsSupplier: new FormControl<boolean>(false),
            MaintenanceFee: new FormControl<number | null>(null),
            MySupplierCustomerNumber: new FormControl<SupplierCustomerNumber[] | null>(null),
        },
        { validators: [someRequiredValidator(['IsSupplier', 'CustomerSpecificationType'])], asyncValidators: [] },
    );

    public CustomerIdForm = this.CustomerForm.controls.CustomerId;
    public DescriptionForm = this.CustomerForm.controls.Description;
    public HomepageForm = this.CustomerForm.controls.Homepage;
    public MandateTypeIdForm = this.CustomerForm.controls.MandateTypeId;
    public UstIdForm = this.CustomerForm.controls.UstId;
    public SteuernummerForm = this.CustomerForm.controls.Steuernummer;
    public SachkontochartOfAccounts: Array<ChartOfAccountEntity & { optionLabel: string }>;
    public KontochartOfAccounts: Array<ChartOfAccountEntity & { optionLabel: string }>;
    public ChartOfAccounts: Array<ChartOfAccountEntity>;

    /** FormGroup für die Standortdaten */
    private officeForm = new FormGroup({
        PhoneNumber: new FormControl<string | null>(null, phoneNumberValidator()),
        Email: new FormControl<string | null>(null, Validators.email),
        InvoiceEmail: new FormControl<string | null>(null, Validators.email),
        Street: new FormControl<string | null>(null),
        PostalCode: new FormControl<string | null>(null),
        City: new FormControl<string | null>(null),
        Country: new FormControl<string | null>(null),
        FaxNumber: new FormControl<string | null>(null),
        MobileNumber: new FormControl<string | null>(null),
        IBAN: new FormControl<string | null>(null),
        Swift: new FormControl<string | null>(null),
        BankName: new FormControl<string | null>(null),
        BankLocation: new FormControl<string | null>(null),
        BankPostalCode: new FormControl<string | null>(null),
        BankSortCode: new FormControl<string | null>(null),
        MobileNumber2: new FormControl<string | null>(null),
    });

    public PhoneNumberForm = this.officeForm.controls.PhoneNumber;
    public EmailForm = this.officeForm.controls.Email;
    public InvoiceEmailForm = this.officeForm.controls.InvoiceEmail;
    public StreetForm = this.officeForm.controls.Street;
    public PostalCodeForm = this.officeForm.controls.PostalCode;
    public CityForm = this.officeForm.controls.City;
    public CountryForm = this.officeForm.controls.Country;
    public FaxNumberForm = this.officeForm.controls.FaxNumber;
    public MobileNumberForm = this.officeForm.controls.MobileNumber;
    public IBANForm = this.officeForm.controls.IBAN;
    public SwiftForm = this.officeForm.controls.Swift;
    public BankNameForm = this.officeForm.controls.BankName;
    public BankLocationForm = this.officeForm.controls.BankLocation;
    public BankPostalCodeForm = this.officeForm.controls.BankPostalCode;
    public BankSortCodeForm = this.officeForm.controls.BankSortCode;
    public MobileNumberForm2 = this.officeForm.controls.MobileNumber2;
    private mandateTypes$ = getFetched$(this.store, getMandateTypesFetched, getMandateTypes);

    @Input() set PreventNewPersonDialog(value) {
        this.preventNewPersonDialog = coerceBooleanProperty(value);
    }
    protected hideSuppliersInCommission: boolean;
    @Input() set HideSuppliersInCommission(value) {
        this.hideSuppliersInCommission = coerceBooleanProperty(value);
    }

    private combinedNameValidator(max: number, fieldNames: [string, string], lengthdescription: string = ''): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!this.kaplCustomerProperties) {
                return null;
            }
            const other = control === this.FirstnameForm ? this.LastNameForm : this.FirstnameForm;
            const combinedLength = (control.value || '').length + (other?.value || '').length;

            return combinedLength > max
                ? { combinedMaxLength: { max, actual: combinedLength, fieldNames, lengthdescription } }
                : null;

        };
    }

    protected kaplCustomerProperties: boolean;
    @Input() set KaplCustomerProperties(value) {
        this.kaplCustomerProperties = coerceBooleanProperty(value);

        if (this.kaplCustomerProperties) {
                this.subscriptions.push(
                    this.FirstnameForm.valueChanges.subscribe(() =>
                        this.LastNameForm.updateValueAndValidity(),
                    ),
                    this.LastNameForm.valueChanges.subscribe(() =>
                        this.FirstnameForm.updateValueAndValidity(),
                    ),
                );

            this.FirstnameForm.setValidators(
                [Validators.required, this.combinedNameValidator(27, ['Name 1', 'Name 2'], ' (30 - 3 leerzeichen und "&")-')],
            );
            this.LastNameForm.setValidators(
                 [Validators.required, this.combinedNameValidator(27, ['Name 1', 'Name 2'], ' (30 - 3 leerzeichen und "&")-')]
                    ,
            );
            this.StreetForm.setValidators([Validators.maxLength(30)]);
            this.CityForm.setValidators([Validators.maxLength(30)]);

            this.PhoneNumberForm.setValidators(
                 [phoneNumberValidator(), Validators.maxLength(20)]
                   ,
            );
            this.FaxNumberForm.setValidators([Validators.maxLength(20)]);
            this.MobileNumberForm.setValidators([Validators.maxLength(20)]);
            this.MobileNumberForm2.setValidators([Validators.maxLength(20)]);
            this.DescriptionForm.setValidators([Validators.maxLength(30)]);
            this.NameForm.setValidators([Validators.maxLength(30)]);

            this.EmailForm.setValidators(
                 [Validators.email, Validators.maxLength(70)]
                   ,
            );

            this.InvoiceEmailForm.setValidators(
                [Validators.email, Validators.maxLength(70)]
                   ,
            );

            [
                this.FirstnameForm, this.LastNameForm, this.StreetForm, this.CityForm,
                this.PhoneNumberForm, this.FaxNumberForm, this.MobileNumberForm, this.MobileNumberForm2,
                this.DescriptionForm, this.NameForm,
                this.EmailForm,
            ].forEach((c) => c.updateValueAndValidity({ emitEvent: false }));
        }
    }

    @Input() newPersonCommissionId: number;
    // tslint:disable-next-line: member-ordering naming-convention
    static ngAcceptInputType_PreventNewPersonDialog: BooleanInput;
    private preventNewPersonDialog = false;
    @Input() set DefaultValues(value: newCustomerDefaultValues) {
        if (!value) {
            return;
        }
        if (value.name) {
            this.NameForm.setValue(value.name);
        }
        if (value.firstName) {
            this.FirstnameForm.setValue(value.firstName);
        }
        if (value.lastName) {
            this.LastNameForm.setValue(value.lastName);
        }
        if (value.customer) {
            for (const k in value.customer) {
                if (value.customer[k] !== undefined) {
                    this.CustomerForm.controls[k].setValue(value.customer[k]);
                }
            }
        }
        if (value.office) {
            for (const k in value.office) {
                if (value.office[k] !== undefined) {
                    this.officeForm.controls[k].setValue(value.office[k]);
                }
            }
        }
    }

    public CustomerSpecificationtypes$ = this.store.select(getCustomerSpecificationTypes);
    private subscriptions: Subscription[] = [];
    public PartnerOffices$ = this.store.select(getPartnerOfficesFetched).pipe(
        filter((fetched) => fetched),
        switchMap(() => this.store.select(getOwnPartnerOffices)),
    );
    public Customer$ = new BehaviorSubject<CustomerEntity | null>(null);
    public OtherCustomerWithSameNumber$: Observable<CustomerEntity[] | undefined> = this.Customer$.pipe(
        map((c) => c?.Id),
        distinctUntilChanged(),
        switchMap((customerId) =>
            this.store.select(getCustomers).pipe(
                map((customers) => {
                    const customerNumberMap: { [key: string]: CustomerEntity[] } = {};
                    customers.forEach((c) => {
                        if (c.CustomerNo && c.Id !== customerId) {
                            if (!customerNumberMap[c.CustomerNo]) {
                                customerNumberMap[c.CustomerNo] = [];
                            }
                            customerNumberMap[c.CustomerNo].push(c);
                        }
                    });
                    return customerNumberMap;
                }),
            ),
        ),
        switchMap((customerNumberMap) =>
            this.CustomerForm.controls.CustomerId.valueChanges.pipe(
                startWith(this.CustomerForm.controls.CustomerId.value),
                debounceTime(SearchQueriesDebounceTime),
                distinctUntilChanged(),
                map((number: string) => customerNumberMap[(number || '').trim()]),
            ),
        ),
        shareReplay({ bufferSize: 1, refCount: true }),
    );

    /** (NN) Ob die Eingabefelder Validierungsfehler enthalten */
    public AreFormsInvalid$ = combineLatest([
        // startWith(null) produziert deprecation-Warnungen, weil wir kein Null Checking haben...
        this.NameForm.statusChanges.pipe(startWith('')),
        this.CustomerForm.statusChanges.pipe(startWith('')),
        this.CustomerForm.valueChanges.pipe(
            tap(() => this.CustomerForm.updateValueAndValidity({ emitEvent: false })),
            startWith(''),
        ),
        this.officeForm.statusChanges.pipe(startWith('')),
    ]).pipe(
        map(() => this.CustomerForm.invalid || this.officeForm.invalid || this.NameForm.invalid),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    public CompareSelectSearchChartOfAccountsOptions = (a: ChartOfAccountEntity & SelectSearchOption, b: ChartOfAccountEntity & SelectSearchOption) => a.Id === b.Id;

    public SelectSearchChartOfAccountsOptionsFunction = (search: string, option: ChartOfAccountEntity) => [option.Name, option.Number.toString()].some((v) => v && stringSearch(v, search));

    public CompareSelectSearchCustomerSpecTypeOptions = (a: CustomerSpecificationTypeEntity & SelectSearchOption, b: CustomerSpecificationTypeEntity & SelectSearchOption) => a.Id === b.Id;

    public SelectSearchCustomerSpecTypeOptionsFunction = (search: string, option: CustomerSpecificationTypeEntity) => [option.Name].some((v) => v && stringSearch(v, search));

    addSupplierCustomerNumber() {
        this.SupplierCustomerNumbers.push({ number: '', description: null });
        this.CustomerForm.controls.MySupplierCustomerNumber.setValue(this.SupplierCustomerNumbers);
        this.CustomerForm.controls.MySupplierCustomerNumber.markAsDirty();
    }

    removeSupplierCustomerNumber(index: number) {
        this.SupplierCustomerNumbers.splice(index, 1);
        this.CustomerForm.controls.MySupplierCustomerNumber.setValue(this.SupplierCustomerNumbers);
        this.CustomerForm.controls.MySupplierCustomerNumber.markAsDirty();
    }

    public CustomerSpecificationTypeOptions$: Observable<{ Id: number; Name: string; PartnerId: number; optionLabel: string }[]> = getFetched$(this.store, getCustomerSpecificationTypesFetched, getCustomerSpecificationTypes, this.customerSpecificationTypeResolver).pipe(
        map((types) =>
            types.map((type) => ({
                Id: type.Id,
                Name: type.Name,
                PartnerId: type.PartnerId,
                optionLabel: type.Name,
            })),
        ),
    );

    private updateNameFormValidators(): void {
        const validators: ValidatorFn[] = [];
        if (!this.isPrivatePerson) {
            validators.push(Validators.required);
        }
        if (this.kaplCustomerProperties) {
            validators.push(Validators.maxLength(30));
        }
        this.NameForm.setValidators(validators.length ? validators : null);
        this.NameForm.updateValueAndValidity({ emitEvent: false });
    }

    protected suppliersLabel$: Observable<string> = this.cls.getMultiple$('Supplier');
    protected customerRolesLabel$: Observable<string> = this.cls.getMultiple$('Customer');
    protected customerNumberLabel$: Observable<string> = this.cls.getSingle$('CustomerNumber');
    protected supplierNumberLabel$: Observable<string> = this.cls.getLabels$('Supplier').pipe(map(s => s.wordBinding+'nummer'));
    protected hideCustomerNumber: boolean = false;
    constructor(
        private fb: UntypedFormBuilder,
        private googleGeocoderService: GoogleMapsService,
        private routingHistoryService: RoutingHistoryService,
        private store: Store<State>,
        private dialog: MatDialog,
        protected chartOfAccountResolver: ChartOfAccountResolver,
        protected customerTypeResolver: CustomerTypeResolver,
        protected customerSpecificationTypeResolver: CustomerSpecificationTypeResolver,
        private actions$: Actions,
        protected ls: LoadingService,
        protected cls: CustomLabelService,
    ) {
        firstValueFrom(this.store.select(getPartner)).then(p => {
            if (p?.AdditionalData?.defaultCountry && this.officeForm.controls.Country.pristine && this.officeForm.value.Country !== p.AdditionalData.defaultCountry) {
                this.officeForm.controls.Country.setValue(p.AdditionalData.defaultCountry);
            }
            if (p?.AdditionalData?.defaultTaxTypeId && this.CustomerForm.controls.TaxTypeId.pristine && this.CustomerForm.value.TaxTypeId !== p.AdditionalData.defaultTaxTypeId) {
                this.CustomerForm.controls.TaxTypeId.setValue(p.AdditionalData.defaultTaxTypeId);
            }
        })
        firstValueFrom(this.store.select(getCustomerTypeFetched)).then(f => {
            if (!f) {
                this.customerTypeResolver.resolve();
            }
        })
        firstValueFrom(getFetched$(this.store, getPartnerFetched, getPartner)).then((partner) => {
            const autoCustomerNumber =
                partner.AdditionalData?.createCustomerNumberAutomaticDefault ?? true;
             this.hideCustomerNumber =
                partner.AdditionalData?.hideAutomaticCustomerNumberAndCustomerNumber ?? false;
            if (autoCustomerNumber !== this.CustomerForm.value.AutomaticCustomerId) {
                this.CustomerForm.controls.AutomaticCustomerId.setValue(autoCustomerNumber);
            }
        });
        /** (NN) Ob der zu erstellende Kunde eine Privatperson (statt eines Unternehmens) ist */
        this.Data$ = combineLatest([
            // areFormsInvalid$,
            this.store.select(getMandateTypes),
        ]).pipe(
            map(([MandateTypes]) => ({
                // AreFormsInvalid,
                MandateTypes,
            })),
        );
        firstValueFrom(this.mandateTypes$).then((MandateType) => {
            const defaultType = MandateType.find((mt) => mt.Name === MandateTypeNames.debitor);
            this.MandateTypeIdForm.setValue(defaultType.Id);
        });

        firstValueFrom(this.store.select(getChartOfAccountsFetched)).then((fetched) => {
            if (!fetched) {
                chartOfAccountResolver.resolve();
            }
        });

        this.subscriptions.push(
            this.PartnerOffices$.pipe(
                map((partners) => {
                    let partnerValues = {};

                    partnerValues['-'] = 'keinen auswählen';

                    partners.forEach((partner) => {
                        partnerValues[partner.Id.toString()] = partner.DisplayName;
                    });
                    return partnerValues;
                }),
            ).subscribe(),
            this.CustomerForm.controls.CustomerSpecificationType.valueChanges.pipe(filter(isNotNullOrUndefined)).subscribe((v) => {
                if (v.Name.toLocaleLowerCase().includes('gericht') && this.CustomerForm.controls.Gerichtsort.disabled) {
                    this.CustomerForm.controls.Gerichtsort.enable();
                } else if (!v.Name.toLocaleLowerCase().includes('gericht') && this.CustomerForm.controls.Gerichtsort.enabled) {
                    this.CustomerForm.controls.Gerichtsort.disable();
                    this.CustomerForm.controls.Gerichtsort.setValue(null);
                }
            }),
            this.CustomerForm.controls.AutomaticCustomerId.valueChanges.subscribe((v) => {
                if (v && this.CustomerForm.controls.CustomerId.enabled) {
                    this.CustomerForm.controls.CustomerId.disable();
                    this.CustomerForm.controls.CustomerId.setValue(null);
                } else if (!v && this.CustomerForm.controls.CustomerId.disabled) {
                    this.CustomerForm.controls.CustomerId.enable();
                }
            }),
            this.CustomerForm.controls.CustomerSpecificationType.valueChanges.subscribe((value) => {
                if (value && value.Name) {
                    this.isPrivatePerson = value.Name.toLowerCase() === 'privatperson';
                } else {
                    this.isPrivatePerson = false;
                }
                this.updateNameFormValidators();
            }),
            combineLatest([this.CustomerForm.controls.IsSupplier.valueChanges, this.mandateTypes$]).subscribe(([value, mandateTypes]) => {
                this.isSupplier = value;
                const mdName = value ? MandateTypeNames.kreditor : MandateTypeNames.debitor;
                const mdId = mandateTypes.find((m) => m.Name === mdName)?.Id;
                if (this.isSupplier) {
                    this.CustomerForm.controls.CustomerSpecificationType.disable({emitEvent: false});
                    this.CustomerForm.controls.CustomerSpecificationType.setValue(null, {emitEvent: false});
                    this.MandateTypeIdForm.setValue(mdId);
                } else {
                    this.CustomerForm.controls.CustomerSpecificationType.enable({emitEvent: false});
                    this.MandateTypeIdForm.setValue(mdId);
                }
            }),
            this.FirstnameForm.valueChanges.subscribe(() =>
                this.LastNameForm.updateValueAndValidity({ emitEvent: false }),
            ),
            this.LastNameForm.valueChanges.subscribe(() =>
                this.FirstnameForm.updateValueAndValidity({ emitEvent: false }),
            ),
        );

        this.subscriptions.push(
            this.store
                .select(getChartOfAccountsFetched)
                .pipe(
                    filter((f) => f),
                    switchMap(() => this.store.select(getChartOfAccounts).pipe(map((ca) => ca.filter((p) => !p.DeletedAt)))),
                )
                .subscribe((chartAcc) => {
                    this.SachkontochartOfAccounts = chartAcc.filter((ca) => ca.AccountType === AccountTypeEnum.Contra).map((r) => Object.assign(r.Clone()));
                    this.KontochartOfAccounts = chartAcc.filter((ca) => ca.AccountType === AccountTypeEnum.Normal).map((r) => Object.assign(r.Clone()));
                    this.ChartOfAccounts = chartAcc.map((r) => Object.assign(r.Clone()));
                }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((v) => v.unsubscribe());
    }

    ngAfterViewInit() {
        this.companySelect.clickInput();
    }

    public Cancel() {
        this.CustomerForm.reset({}, { emitEvent: false });
        this.officeForm.reset({}, { emitEvent: false });
        this.NameForm.reset({}, { emitEvent: false });

        this.routingHistoryService.NavigateBackwards();
    }

    public async Submit(): Promise<number | null> {
        let OtherCustomerWithSameNumber = await firstValueFrom(this.OtherCustomerWithSameNumber$);

        if (OtherCustomerWithSameNumber?.length) {
            const customerNoLabel = await firstValueFrom(this.cls.getLabels$('CustomerNumber'));

            const [forceDuplicateNumber] = await firstValueFrom(
                this.dialog
                    .open<AppConfirmationDialogComponent, AppConfirmationDialogData, AppConfirmationDialogReturnData>(AppConfirmationDialogComponent, {
                        autoFocus: false,
                        data: {
                            heading: customerNoLabel.Nominativ.singular.value + ' bereits vergeben',
                            paragraph: capitalizeFirstLetter(customerNoLabel.Nominativ.singular.article) + ' ' + customerNoLabel.Nominativ.singular.value + ' ist bereits vergeben, möchten Sie dennoch speichern ?',
                        },
                    })
                    .afterClosed(),
            );
            if (!forceDuplicateNumber) {
                return null
            }
        }

        let ret: number;

        const areFormsInvalid = await firstValueFrom(this.AreFormsInvalid$);
        if (areFormsInvalid) {
            return null;
        }
        if (this.StreetForm.value && this.CityForm.value && this.CountryForm.value) {
            const address = [this.StreetForm.value.trim(), this.PostalCodeForm.value.trim(), this.CityForm.value.trim(), this.CountryForm.value.trim()].join();
            const {Latitude, Longitude} =  await firstValueFrom(this.googleGeocoderService.Geocode(address));
            ret = await this.submit(Longitude, Latitude);
        } else {
            ret = await this.submit();
        }

        this.CustomerForm.reset({}, { emitEvent: false });
        this.officeForm.reset({}, { emitEvent: false });
        this.NameForm.reset({}, { emitEvent: false });

        return ret;
    }

    private shouldCreatePerson() {
        if (!this.preventNewPersonDialog && this.isPrivatePerson) {
            return firstValueFrom(
                this.dialog
                    .open<AppConfirmationDialogComponent, AppConfirmationDialogData, AppConfirmationDialogReturnData>(AppConfirmationDialogComponent, {
                        data: {
                            heading: 'Möchten Sie auch einen Kontakt anlegen?',
                            noButton: 'Nein, weiter',
                            // styleDelete: true,
                        },
                    })
                    .afterClosed()
                    .pipe(map((res) => !!(res && res[0]))),
            );
        }
        return firstValueFrom(of(false));
    }
    private submit(Longitude: number = null, Latitude: number = null): Promise<number> {
        const values = {
            Name: this.NameForm.value,
            ...this.CustomerForm.value,
            ...this.officeForm.value,
        };
        if (!isNotNullOrUndefined(this.LastNameForm.value)) {
            this.LastNameForm.setValue('');
        }
        return firstValueFrom(combineLatest([this.store.select(getUser), this.PartnerOffices$, this.shouldCreatePerson()])).then(([user, ownPartnerOffices, createPerson]) => {
            const actionPayload: DaveMutationCreateCustomerWithOfficePersonArgs = {
                partnerId: user.PartnerId,
                name: this.isPrivatePerson
                    ? this.FirstnameForm?.value !== null
                        ? this.LastNameForm?.value !== ''
                            ? this.FirstnameForm?.value + ' & ' + this.LastNameForm?.value
                            : this.FirstnameForm?.value
                        : this.LastNameForm?.value
                    : values.Name,
                customerNo: values.CustomerId,
                description: values.Description,
                gerichtsort: values.Gerichtsort,
                customerSpecificationTypeId: this.CustomerForm.value.IsSupplier ? null : values.CustomerSpecificationType.Id,
                sales: values.Sales,
                employeeNumber: values.EmployeeNumber,
                customerTypeIds: this.CustomerTypesForm.value?.map((v) => v.Id),
                homepage: values.Homepage,
                mandateTypeIds: values.MandateTypeId ? [values.MandateTypeId] : [],
                automaticCustomerNo: values.AutomaticCustomerId,
                automaticAccountsReceivableLedger: values.AutomaticAccountsReceivableLedger ? 1 : 2,
                ustId: values.UstId,
                steuernummer: values.Steuernummer,
                partnerOfficeId: ownPartnerOffices?.length > 1 ? values.PartnerOfficeId.Id : ownPartnerOffices?.length ? ownPartnerOffices[0]?.Id : null,
                debitorNo: values.DebitorNo,
                taxTypeId: values.TaxTypeId,
                customerStatus: CustomerStatusEnum.Aktiv,
                sachkontoCOAId: this.CustomerForm.controls.Sachkonto?.value?.Id,
                kontoCOAId: this.CustomerForm.value?.Konto?.Id,
                buyerReference: this.CustomerForm.value.BuyerReference,
                paymentTerms: this.CustomerForm.value.PaymentTerms,
                paymentTargetInDays: this.CustomerForm.value.PaymentTargetInDays,
                paymentDiscount: this.CustomerForm.value.PaymentDiscount,
                paymentDiscountTargetInDays: this.CustomerForm.value.PaymentDiscountTargetInDays,
                isSupplier: this.CustomerForm.value.IsSupplier,
                maintenanceFee: this.CustomerForm.value.MaintenanceFee,
                addedMySupplierCustomerNumber: this.SupplierCustomerNumbers?.length > 0
                    ? this.SupplierCustomerNumbers.map(item => JSON.stringify(item))
                    : null,
                office: {
                    email: values.Email,
                    invoiceEmail: values.InvoiceEmail,
                    isHeadquarter: true,
                    phoneNumber: values.PhoneNumber,
                    street: values.Street,
                    postalCode: values.PostalCode,
                    city: values.City,
                    country: values.Country,
                    longitude: Longitude,
                    latitude: Latitude,
                    faxNumber: values.FaxNumber,
                    mobileNumber: values.MobileNumber,
                    iBAN: values.IBAN,
                    swift: values.Swift,
                    bankName: values.BankName,
                    bankLocation: values.BankLocation,
                    bankPostalCode: values.BankPostalCode,
                    bankSortCode: values.BankSortCode,
                    mobileNumber2: values.MobileNumber2,
                },
                person: createPerson
                    ? {
                          firstname: this.FirstnameForm.value ? this.FirstnameForm.value : null,
                          lastname: this.LastNameForm?.value,
                          email: values.Email,
                          phoneNumber: values.PhoneNumber,
                          mobileNumber: values.MobileNumber,
                          faxNumber: values.FaxNumber,
                          street: values.Street,
                          postalCode: values.PostalCode,
                          city: values.City,
                          country: values.Country,
                      }
                    : null,
            };
            this.ls.startLoading('new-customer-main.component_Submit');
            this.store.dispatch(
                CustomerActionTypes.AddCustomerAndOffice({
                    Payload: actionPayload,
                }),
            );
            return firstValueFrom(this.actions$.pipe(ofType(CustomerActionTypes.AddCustomerAndOfficeSuccess, BaseActionTypes.ErrorAction))).then(async (action) => {
                this.ls.endLoading('new-customer-main.component_Submit');

                if (action.type === CustomerActionTypes.AddCustomerAndOfficeSuccess.type) {
                    this.CustomerForm.reset(this.CustomerForm.value);
                    this.officeForm.reset(this.officeForm.value);
                    this.NameForm.reset(this.NameForm.value);
                    const customerId = action.Payload.Customer.Id;

                    if (createPerson && this.newPersonCommissionId) {
                        this.store.dispatch(
                            Person2EntityActionTypes.AddPerson2Entity({
                                Payload: {
                                    entityId: this.newPersonCommissionId,
                                    personId: action.Payload.Person.Id,
                                    entityType: Person2EntityEntityTypeEnum.Commission,
                                    complaintTypeId: ComplaintTypeIdEnum.beteiligtePerson,
                                },
                            }),
                        );
                        await firstValueFrom(this.actions$.pipe(ofType(Person2EntityActionTypes.UpdateMany, BaseActionTypes.ErrorAction)));
                    }


                    if (this.createCustomerAndSupplier) {
                        this.store.dispatch(
                            CustomerActionTypes.AddCustomerAndOffice({
                                Payload: { ...actionPayload, isSupplier: !actionPayload.isSupplier, person: null },
                            }),
                        );
                        const secondCustomerAction = await firstValueFrom(this.actions$.pipe(ofType(CustomerActionTypes.AddCustomerAndOfficeSuccess, BaseActionTypes.ErrorAction)))
                        if (secondCustomerAction.type === CustomerActionTypes.AddCustomerAndOfficeSuccess.type) {
                            if (createPerson) {
                                this.store.dispatch(
                                    Person2EntityActionTypes.AddPerson2Entity({
                                        Payload: {
                                            entityId: secondCustomerAction.Payload.Customer.Id,
                                            personId: action.Payload.Person.Id,
                                            entityType: Person2EntityEntityTypeEnum.Customer,
                                        },
                                    }),
                                );
                                return firstValueFrom(this.actions$.pipe(ofType(Person2EntityActionTypes.UpdateMany, BaseActionTypes.ErrorAction))).then(() => customerId);
                            } else {
                                return customerId;
                            }
                        } else {
                            throw 'create customer failed';
                        }
                    }
                    return customerId;
                } else {
                    throw 'create customer failed';
                }
            });
        });
    }

    @HostListener('window:beforeunload')
    // tslint:disable-next-line:naming-convention
    canDeactivate(): Observable<boolean> | boolean {
        return !this.CustomerForm.dirty && !this.officeForm.dirty && !this.NameForm.dirty;
    }

    newCustomerSpecTypePopUp(entity?: CustomerSpecificationTypeEntity) {
        combineLatest([
            this.suppliersLabel$,
            this.cls.getMultiple$('CustomerSpecificationType'),
        ]).pipe(take(1),map(([suppliersLabel, customerSpecificationTypeLabel]) => {
            let customerSpecType: { Id: number; Name: string; PartnerId: number; optionLabel: string } | null = null;
            this.CustomerSpecificationTypeOptions$.subscribe((options) => {
                const selectedOption = options.find(
                    (option) => option.Id === entity?.Id
                );
                if (selectedOption) {
                    customerSpecType = selectedOption;
                }
            });
            const name = new FormControl<string>(customerSpecType?.Name ? customerSpecType.Name : '', Validators.required);

            this.dialog
                .open<DetailListTemplateDialogComponent, DetailListTemplateDialogData, DetailListDialogReturn>(DetailListTemplateDialogComponent, {
                    ...DetailListTemplateDialogComponent.DefaultConfig,
                    data: {
                        DisableSaveButton$: name.statusChanges.pipe(
                            startWith(name.status),
                            map((state) => state !== 'VALID'),
                        ),
                        Editing: true,
                        DeleteButton: !!customerSpecType,
                        Data: {
                            Headline: customerSpecType ? (customerSpecType.Name ? customerSpecType.Name + ' bearbeiten' :  this.CustomerForm.value.IsSupplier ? (suppliersLabel+'art') : customerSpecificationTypeLabel + ' bearbeiten') : this.CustomerForm.value.IsSupplier ? 'Neue '+suppliersLabel +'art anlegen': 'Neue '+ customerSpecificationTypeLabel +' anlegen',
                            Properties: [
                                {
                                    key: 'Name',
                                    formControl: name,
                                },
                            ].filter(isNotNullOrUndefined),
                        },
                    },
                })
                .afterClosed()
                .subscribe((ret) => {
                    if (ret.Action === 'delete') {
                        this.store.dispatch(CustomerSpecificationTypeActionTypes.Delete({ Payload: { id: customerSpecType.Id } }));
                    }
                    if (ret.Action === 'save') {
                        if (!customerSpecType) {
                            this.store.dispatch(
                                CustomerSpecificationTypeActionTypes.Add({
                                    Payload: {
                                        name: name.value,
                                    },
                                }),
                            );
                            this.actions$.pipe(ofType(CustomerSpecificationTypeActionTypes.AddSuccess)).subscribe((res) => {
                                if (res.Payload && res.Payload instanceof CustomerSpecificationTypeEntity) {
                                    this.CustomerForm.controls.CustomerSpecificationType.setValue(res.Payload);
                                }
                            });
                        } else {
                            this.store.dispatch(
                                CustomerSpecificationTypeActionTypes.ChangeCustomerSpecificationType({
                                    Payload: {
                                        id: customerSpecType.Id,
                                        name: name.value,
                                    },
                                }),
                            );
                            this.actions$.pipe(ofType(CustomerSpecificationTypeActionTypes.ChangeSuccess)).subscribe((res) => {
                                if (res.Payload && res.Payload instanceof CustomerSpecificationTypeEntity) {
                                    this.CustomerForm.controls.CustomerSpecificationType.setValue(res.Payload);
                                }
                            });
                        }
                    }
                });
            })
        ).subscribe();
    }

    newChartOfAccountPopUp(entity?: ChartOfAccountEntity, accountType?: AccountTypeEnum) {
        const chartOfAccount = entity ? this.ChartOfAccounts.find((chart) => chart.Id === entity.Id) : null;

        const name = new FormControl<string>(chartOfAccount?.Name ? chartOfAccount.Name : '');
        const description = new FormControl<string>(chartOfAccount?.Description ? chartOfAccount.Description : '');
        const number = new FormControl<number>(chartOfAccount?.Number ? chartOfAccount.Number : null, Validators.required);

        this.dialog
            .open<DetailListTemplateDialogComponent, DetailListTemplateDialogData, DetailListDialogReturn>(DetailListTemplateDialogComponent, {
                ...DetailListTemplateDialogComponent.DefaultConfig,
                data: {
                    DisableSaveButton$: number.statusChanges.pipe(
                        startWith(number.status),
                        map((state) => state !== 'VALID'),
                    ),
                    Editing: true,
                    DeleteButton: !!chartOfAccount,
                    Data: {
                        Headline: chartOfAccount ? (chartOfAccount.Name ? chartOfAccount.Name + ' bearbeiten' : 'Konto bearbeiten') : 'Neues Konto anlegen',
                        Properties: [
                            {
                                key: 'Name',
                                formControl: name,
                            },
                            {
                                key: 'Nummer',
                                formControl: number,
                                options: {
                                    specialInput: {
                                        number: true,
                                    },
                                },
                            },
                            {
                                key: 'Bezeichnung',
                                formControl: description,
                            },
                        ].filter(isNotNullOrUndefined),
                    },
                },
            })
            .afterClosed()
            .subscribe((ret) => {
                if (ret?.Action === 'delete') {
                    this.store.dispatch(ChartOfAccountActionTypes.Delete({ Payload: { id: chartOfAccount.Id } }));
                }
                if (ret?.Action === 'save') {
                    if (!chartOfAccount) {
                        this.store.dispatch(
                            ChartOfAccountActionTypes.Add({
                                Payload: {
                                    description: description.value,
                                    name: name.value,
                                    number: number.value,
                                    accountType: accountType,
                                },
                            }),
                        );
                        this.actions$.pipe(ofType(ChartOfAccountActionTypes.AddSuccess)).subscribe((res) => {
                            if (res.Payload) {
                                if (res.Payload.AccountType === AccountTypeEnum.Contra) {
                                    this.CustomerForm.controls.Sachkonto.setValue(Object.assign(res.Payload));
                                }
                                if (res.Payload.AccountType === AccountTypeEnum.Normal) {
                                    this.CustomerForm.controls.Konto.setValue(Object.assign(res.Payload));
                                }
                            }
                        });
                    } else {
                        this.store.dispatch(
                            ChartOfAccountActionTypes.ChangeChartOfAccount({
                                Payload: {
                                    id: chartOfAccount.Id,
                                    description: description.value,
                                    name: name.value,
                                    number: number.value,
                                    accountType: chartOfAccount.AccountType,
                                },
                            }),
                        );
                        this.actions$.pipe(ofType(ChartOfAccountActionTypes.ChangeSuccess)).subscribe((res) => {
                            if (res.Payload) {
                                if (res.Payload.AccountType === AccountTypeEnum.Contra) {
                                    this.CustomerForm.controls.Sachkonto.setValue(Object.assign(res.Payload));
                                }
                                if (res.Payload.AccountType === AccountTypeEnum.Normal) {
                                    this.CustomerForm.controls.Konto.setValue(Object.assign(res.Payload));
                                }
                            }
                        });
                    }
                }
            });
    }

    protected readonly AccountTypeEnum = AccountTypeEnum;
}
